import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetUserPreferenceMutationVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ResetUserPreferenceMutation = { __typename?: 'Mutation', deleteJobSeekerProfileStructuredDataPreferenceAttributes?: { __typename?: 'DeleteJobSeekerProfileStructuredDataPreferenceAttributesPayload', positivePreferenceAttributeIds?: Array<string> | null, dislikedPreferenceAttributeIds?: Array<string> | null } | null };

export type ResetUserMinimumPayPreferenceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ResetUserMinimumPayPreferenceMutation = { __typename?: 'Mutation', updateJobSeekerProfileStructuredDataPreference?: { __typename?: 'UpdateJobSeekerProfileStructuredDataPreferencePayload', preference?: { __typename?: 'JobSeekerProfileStructuredDataPreference', minimumPay?: { __typename?: 'JobSeekerProfileStructuredDataSalary', id?: string | null, amount?: number | null, amountExists?: boolean | null, salaryType?: Types.JobSeekerProfileStructuredDataSalaryType | null, sentiment: Types.JobSeekerProfileStructuredDataSentiment } | null } | null } | null };


export const ResetUserPreferenceDocument = gql`
    mutation ResetUserPreference($ids: [ID!]) {
  deleteJobSeekerProfileStructuredDataPreferenceAttributes(input: {ids: $ids}) {
    positivePreferenceAttributeIds
    dislikedPreferenceAttributeIds
  }
}
    `;
export type ResetUserPreferenceMutationFn = Apollo.MutationFunction<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>;

/**
 * __useResetUserPreferenceMutation__
 *
 * To run a mutation, you first call `useResetUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPreferenceMutation, { data, loading, error }] = useResetUserPreferenceMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useResetUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>(ResetUserPreferenceDocument, options);
      }
export type ResetUserPreferenceMutationHookResult = ReturnType<typeof useResetUserPreferenceMutation>;
export type ResetUserPreferenceMutationResult = Apollo.MutationResult<ResetUserPreferenceMutation>;
export type ResetUserPreferenceMutationOptions = Apollo.BaseMutationOptions<ResetUserPreferenceMutation, ResetUserPreferenceMutationVariables>;
export const ResetUserMinimumPayPreferenceDocument = gql`
    mutation ResetUserMinimumPayPreference($id: ID!) {
  updateJobSeekerProfileStructuredDataPreference(
    input: {minimumPay: {amount: 0, currency: "USD", salaryType: YEARLY}, id: $id}
  ) {
    preference {
      minimumPay {
        id
        amount
        amountExists
        salaryType
        sentiment
      }
    }
  }
}
    `;
export type ResetUserMinimumPayPreferenceMutationFn = Apollo.MutationFunction<ResetUserMinimumPayPreferenceMutation, ResetUserMinimumPayPreferenceMutationVariables>;

/**
 * __useResetUserMinimumPayPreferenceMutation__
 *
 * To run a mutation, you first call `useResetUserMinimumPayPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserMinimumPayPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserMinimumPayPreferenceMutation, { data, loading, error }] = useResetUserMinimumPayPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetUserMinimumPayPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserMinimumPayPreferenceMutation, ResetUserMinimumPayPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserMinimumPayPreferenceMutation, ResetUserMinimumPayPreferenceMutationVariables>(ResetUserMinimumPayPreferenceDocument, options);
      }
export type ResetUserMinimumPayPreferenceMutationHookResult = ReturnType<typeof useResetUserMinimumPayPreferenceMutation>;
export type ResetUserMinimumPayPreferenceMutationResult = Apollo.MutationResult<ResetUserMinimumPayPreferenceMutation>;
export type ResetUserMinimumPayPreferenceMutationOptions = Apollo.BaseMutationOptions<ResetUserMinimumPayPreferenceMutation, ResetUserMinimumPayPreferenceMutationVariables>;